import Constants from 'expo-constants'
import { Platform } from 'react-native'

export interface BuildLessonUrlArgs {
  courseSlug: string
  lessonSlug: string
  collectionId?: number
  referrer?: string
  referrerTitle?: string
  courseTitle?: string
  startSeconds?: number
  videoSlug?: string
  includeLoop?: boolean
}

export function parseLessonUrlTimeSeconds(raw: unknown): number | undefined {
  if (raw == null) return undefined
  const s = String(Array.isArray(raw) ? raw[0] : raw).trim()
  if (!s) return undefined
  const normalized = s.replace(/s$/i, '')
  const n = Number.parseInt(normalized, 10)
  if (!Number.isFinite(n) || n < 0) return undefined
  return n
}

export function getLessonShareOrigin(): string {
  if (Platform.OS === 'web' && typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin
  }
  const fromExtra = Constants.expoConfig?.extra?.baseUrl
  if (typeof fromExtra === 'string' && fromExtra.trim()) {
    return fromExtra.replace(/\/$/, '')
  }
  return 'https://openstudiojazz.com'
}

export function buildAbsoluteLessonShareUrl(args: BuildLessonUrlArgs): string {
  return `${getLessonShareOrigin()}${buildLessonUrl(args)}`
}

export function buildLessonUrl({
  courseSlug,
  lessonSlug,
  collectionId,
  referrer,
  referrerTitle,
  courseTitle,
  startSeconds,
  videoSlug,
  includeLoop,
}: BuildLessonUrlArgs): string {
  const params = new URLSearchParams()

  if (collectionId != null) params.set('collectionId', String(collectionId))
  if (referrer) params.set('referrer', referrer)
  if (referrerTitle) params.set('referrerTitle', referrerTitle)
  if (courseTitle) params.set('courseTitle', courseTitle)
  if (startSeconds != null && startSeconds > 0) {
    params.set('t', String(Math.floor(startSeconds)))
  }
  const vs = typeof videoSlug === 'string' ? videoSlug.trim() : ''
  if (vs.length > 0) {
    params.set('video', vs)
  }
  if (includeLoop) {
    params.set('loop', '1')
  }

  const qs = params.toString()
  return qs
    ? `/courses/${courseSlug}/${lessonSlug}?${qs}`
    : `/courses/${courseSlug}/${lessonSlug}`
}
